import React, { FC, useEffect } from "react";
import { FooterContainer } from "../../containers/FooterContainer";

import { HeaderContainer } from "../../containers/HeaderContainer";
import { HeaderActionsContainer } from "../../containers/HeaderActionsContainer";
import { PrivacyPoliciesContainer } from "../../containers/PrivacyPoliciesContainer";

export const PrivacyPoliciesPage: FC = () => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="xvia-main-app">
      <HeaderContainer rightElement={<HeaderActionsContainer />} />
      <PrivacyPoliciesContainer />
      <FooterContainer />
    </div>
  );
};
